import { ReactNode } from 'react';
import { Key } from 'react';

type MenuItem = {
  key: Key;
  icon?: ReactNode;
  children?: MenuItem[];
  label: ReactNode;
  onClick?: () => void;
};

export function getItem({
  label,
  key,
  icon,
  children,
  onClick,
}: MenuItem): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    onClick,
  };
}
